import script from "./UserTag.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTag.vue?vue&type=script&setup=true&lang=js"

import "./UserTag.vue?vue&type=style&index=0&id=fc4e5e52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc4e5e52"]])

export default __exports__